import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: Date): string {
  return new Intl.DateTimeFormat("he-IL", {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(date)
}

export function getGoogleDriveDirectUrl(url: string): string {
  try {
    // Check if it's a Google Drive URL
    if (!url.includes('drive.google.com')) {
      return url;
    }

    // Extract file ID from various Google Drive URL formats
    const fileId = url.match(/\/d\/([^/]*)/)?.[1] ||
                  url.match(/id=([^&]*)/)?.[1];

    if (!fileId) {
      console.warn('Could not extract Google Drive file ID from URL:', url);
      return url;
    }

    // Return direct link format
    return `https://drive.google.com/uc?export=view&id=${fileId}`;
  } catch (error) {
    console.error('Error processing Google Drive URL:', error);
    return url;
  }
}
